import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2df2e4f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "GroundWork" }
const _hoisted_2 = { id: "section1" }
const _hoisted_3 = {
  key: 0,
  class: "BackGround"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CatchCopyFld" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "CatchCopyText" }, [
    /*#__PURE__*/_createTextVNode("女性のための"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("高収入求人情報アプリ")
  ])
], -1))
const _hoisted_5 = { class: "LogoFld" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "OneWordFld" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "OneWordText" }, "チャットで気軽に相談♪")
], -1))
const _hoisted_7 = { class: "StartBtnFld" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Existing-Customer-Fld" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "Existing-Customer-Text" }, "本アプリを既にご利用されている方")
], -1))
const _hoisted_9 = { class: "Existing-Acount-Fld" }
const _hoisted_10 = {
  key: 6,
  class: "NextBtnFld"
}
const _hoisted_11 = {
  key: 0,
  class: "Next-Btn-Fld-Seat"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SexView = _resolveComponent("SexView")!
  const _component_AgeView = _resolveComponent("AgeView")!
  const _component_LiveView = _resolveComponent("LiveView")!
  const _component_MotivationView = _resolveComponent("MotivationView")!
  const _component_LastView = _resolveComponent("LastView")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_ctx.count === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "Logo",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.CountUp && _ctx.CountUp(...args)))
              }, "アプリロゴ")
            ]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "Startbtn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.CountUp && _ctx.CountUp(...args)))
              }, "プロフィール入力")
            ]),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "Existing-Acount-Btn",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.JumpSignInURL && _ctx.JumpSignInURL(...args)))
              }, "既存アカウントで続行する")
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.count === 1)
        ? (_openBlock(), _createBlock(_component_SexView, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.count === 2)
        ? (_openBlock(), _createBlock(_component_AgeView, { key: 2 }))
        : _createCommentVNode("", true),
      (_ctx.count === 3)
        ? (_openBlock(), _createBlock(_component_LiveView, { key: 3 }))
        : _createCommentVNode("", true),
      (_ctx.count === 4)
        ? (_openBlock(), _createBlock(_component_MotivationView, { key: 4 }))
        : _createCommentVNode("", true),
      (_ctx.count === 5)
        ? (_openBlock(), _createBlock(_component_LastView, { key: 5 }))
        : _createCommentVNode("", true),
      (_ctx.count >= 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_ctx.count > 0 && _ctx.count < 5)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: "Next-Btn",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.CountUp && _ctx.CountUp(...args)))
                  }, "次へ")
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}